'use client';
'use strict';

var jsxRuntime = require('react/jsx-runtime');
var material = require('@mui/material');

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function FormieRowContainer(_param) {
    var { children } = _param, props = _object_without_properties_loose(_param, [
        "children"
    ]);
    return /*#__PURE__*/ jsxRuntime.jsx(material.Stack, _extends({
        direction: "row",
        alignItems: "stretch",
        columnGap: 2,
        rowGap: 2,
        flexWrap: {
            xs: 'wrap',
            md: 'nowrap'
        }
    }, props, {
        children: children
    }));
}

module.exports = FormieRowContainer;
